export const getLanguages = (languages: string[] | undefined): Option[] => {
  if (!languages) {
    return [
      {
        label: 'English',
        value: 'en',
      },
    ];
  }

  return languages.map((lang: string) => {
    switch (lang) {
      case 'en':
        return {
          label: 'English',
          value: 'en',
        };
      case 'en-UK':
        return {
          label: 'English',
          value: 'en',
        };
      case 'pl':
        return {
          label: 'Polski',
          value: 'pl',
        };
      case 'es':
        return {
          label: 'Español',
          value: 'es',
        };
      case 'pt':
        return {
          label: 'Português',
          value: 'pt',
        };
      case 'ja':
        return {
          label: '日本',
          value: 'ja',
        };
      default:
        return {
          label: 'English',
          value: 'en',
        };
    }
  });
};
